import { useState } from "react";

import { Dialog, DialogContent, DialogTrigger } from "@fronterahealth/frontera-ui-components/ui/dialog";

import { ReviewRequestForm } from "@components/ReportReview/ReviewRequestForm";

export const ReviewRequestDialog: React.FC<{ trigger: React.ReactElement }> = ({ trigger }) => {
  const [open, setOpen] = useState(false);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger render={trigger} />
      <DialogContent className="sm:max-w-lg">
        <ReviewRequestForm onClose={() => setOpen(false)} />
      </DialogContent>
    </Dialog>
  );
};
